import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Navigation } from '@app/shared/models/navigation.model';

@Injectable()
export class NavigationService {
    private history: Navigation[] = [];

    constructor(private router: Router, private location: Location) {}

    public initialize(): void {
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                map((e) => e)
            )
            .subscribe((event) => {
                const name = event.urlAfterRedirects.split('/').pop();
                this.history.push({ url: event.urlAfterRedirects, name });
            });
    }

    getHistory(): Navigation[] {
        return this.history;
    }

    getPrevious(): Navigation {
        let item: Navigation;

        if (this.history.length > 1) {
            item = this.history[this.history.length - 2];
        }

        return item;
    }

    goBack(): void {
        this.history.pop();

        if (this.history.length) {
            this.location.back();
        }
    }
}
